<template>
    <div class="col-12 pl4 border-box graphic flex flex-column justify-center" id="graphicwrap" style="height: 95%; max-height: 95%; transform: translateX(1.5rem); padding-right: 2.5rem">
        <div v-show="deckendicke > 0" class="meter-large">
            <div class="meter-slash-top"></div>
            <p class="meter-number">{{deckendicke|formatNumber}}</p>
            <div class="meter-slash-bottom"></div>
        </div>

        <div class="flex flex-column meter-holder-right justify-center">
          
          <!-- SUMME DECKENDICKE OBEN -->
          <div 
            v-show="((BetondeckungOben + BewehrungOben + zwischenlageOben + (differenzDeckendicke >= 0 ? differenzDeckendicke : 0) + ((Hohlkoerper.unterstuetzungshoehe - Hohlkoerper.hohlraumhoehe)/2)) > 0) && HKName !== ''" 
            class="meter-large-right relative" 
            :style="{ height: (BetondeckungOben + BewehrungOben + zwischenlageOben + (differenzDeckendicke > 0 ? differenzDeckendicke : 0) + ((Hohlkoerper.unterstuetzungshoehe - Hohlkoerper.hohlraumhoehe)/2)) / deckendicke * 100 + '%'}">
              <div class="meter-slash-top"></div>
                <p class="meter-number-right">
                  {{ r_sumO|formatNumber }}
                </p> 
              <div class="meter-slash-bottom"></div>
          </div>

          <!-- DIFFERENZDECKENDICKE -->

          <!-- <div 
            v-show="differenzDeckendicke > 0" 
            class="meter-large-right relative" 
            :style="{ height: (differenzDeckendicke) / deckendicke * 100 + '%' }"
          >
              <div class="meter-slash-top"></div>
                <p class="meter-number-right">{{differenzDeckendicke}}</p>
              <div class="meter-slash-bottom"></div>
          </div>

          <div 
            v-show="((Hohlkoerper.unterstuetzungshoehe - Hohlkoerper.hohlraumhoehe)/2) > 0" 
            class="meter-large-right relative" 
            :style="{ height: ((Hohlkoerper.unterstuetzungshoehe - Hohlkoerper.hohlraumhoehe)/2) / deckendicke * 100 + '%'}">
              <div class="meter-slash-top"></div>
                <p class="meter-number-right">
                  {{ ((Hohlkoerper.unterstuetzungshoehe - Hohlkoerper.hohlraumhoehe)/2) }}
                </p>
              <div class="meter-slash-bottom"></div>
          </div> -->

          <!-- HOHLRAUMHÖHE -->
          <div 
            v-show="Hohlkoerper.hohlraumhoehe > 0" 
            class="meter-large-right meter-middle-large-right relative" 
            :style="{ height: (Hohlkoerper.hohlraumhoehe) / deckendicke * 100 + '%' }"
          >
              <div class="meter-slash-top"></div>
                <p class="meter-number-right">{{Hohlkoerper.hohlraumhoehe|formatNumber}}</p>
              <div class="meter-slash-bottom"></div>
          </div>

          <!-- SUMME DECKENDICKE UNTEN ORTBETON -->
          <div 
            v-show="((BetondeckungUnten + BewehrungUnten + zwischenlageUnten + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0) + ((Hohlkoerper.unterstuetzungshoehe - Hohlkoerper.hohlraumhoehe) / 2)) > 0) && baustoff == 'Ortbeton' && HKName !== ''" 
            class="meter-large-right relative meter-bottom-large-right" 
            :style="{ height: (BetondeckungUnten + BewehrungUnten + zwischenlageUnten + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0) + ((Hohlkoerper.unterstuetzungshoehe - Hohlkoerper.hohlraumhoehe) / 2)) / deckendicke * 100 + '%'}"
          >
              <div class="meter-slash-top"></div>
                <p class="meter-number-right">
                  {{ r_sumUOB|formatNumber }}
                </p>
              <div class="meter-slash-bottom"></div>
          </div>


          <!-- SUMME DECKENDICKE UNTEN HALBFERTIGTEIL -->
          <div 
            v-show="((querbewehrung + dickeHalbfertigteil + zwischenlageUnten + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0) + ((Hohlkoerper.unterstuetzungshoehe - Hohlkoerper.hohlraumhoehe) / 2)) > 0) && baustoff == 'Halbfertigteil' && HKName !== ''" 
            class="meter-large-right meter-bottom-large-right relative" 
            :style="{ height: (dickeHalbfertigteil + querbewehrung + zwischenlageUnten + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0) + ((Hohlkoerper.unterstuetzungshoehe - Hohlkoerper.hohlraumhoehe) / 2)) / deckendicke * 100 + '%'}">
              <div class="meter-slash-top"></div>
                <p class="meter-number-right">
                  {{ r_sumUHFT|formatNumber }}
                </p>
              <div class="meter-slash-bottom"></div>
          </div>

        </div>

      <div id="graphicbackground" class="h100 flex flex-column justify-center grafik-hintergrund">
        
      <div v-show="BetondeckungOben > 0" class="betondeckung relative" :style="{ height: BetondeckungOben / deckendicke * 100 + '%' }">
        <div class="meter-small">
            <div class="meter-slash-top"></div>
            <p class="meter-number">{{r_bdO|formatNumber}}</p>
            <div class="meter-slash-bottom"></div>
        </div>
      </div>
      <div v-show="BewehrungOben > 0" class="relative" :style="{ height: BewehrungOben / deckendicke * 100 + '%' }">
            <div class="bewehrung-circle-container overflow-hidden flex justify-center col-12">
              
              <div class="no-shrink flex" v-for="index in calcBewDots" :key="'A' + index">
                <div class="bewehrung-circle" :style="{ height: 100 + '%', width: ((BewehrungOben / 2) / deckendicke) * gHeight + 'px'}"></div>
                <div class="no-shrink" :style="{ width: bewehrungGap + 'px'}"></div>
              </div>

              <!-- <div  class="h100" :style="{ width: + 'px'}"></div> -->
            </div>
            <div class="bewehrung" style="height: 50%;"></div>
        <div v-show="BewehrungOben > 0" class="meter-small">
            <div class="meter-slash-top"></div>
              <p class="meter-number">{{r_bewO|formatNumber}}</p>
            <div class="meter-slash-bottom"></div>
        </div>
      </div>
      <div v-show="zwischenlageOben > 0" class="zwischenlage relative" :style="{ height: zwischenlageOben/ deckendicke * 100 + '%' }">
        <div class="meter-small">
          <div class="meter-slash-top"></div>
            <p class="meter-number">{{r_zwlO|formatNumber}}</p>
          <div class="meter-slash-bottom"></div>
        </div>
      </div>

      <!-- DIFFERENZDECKENDICKE -->
       <div v-if="differenzDeckendicke >= 0" class="col-12 border-box" :style="{height: differenzDeckendicke / deckendicke * 100 + '%'}"></div>

      <div v-show="Hohlkoerper.unterstuetzungshoehe > 0" class="relative" :style="{ height: (Hohlkoerper.unterstuetzungshoehe + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0)) / deckendicke * gHeight + 'px' }">
        
        <!-- HOHLKOERPER HALBFERTIGTEIL -->
        <div v-show="baustoff == 'Halbfertigteil'" class="overflow-hidden flex hft-hk-container" :style="{ height: (Hohlkoerper.unterstuetzungshoehe + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0)) / deckendicke * gHeight + 'px' }">
          <div class="flex no-shrink h100" v-for="index in HKNumber" :key="'B' + index">
                <div class="flex no-shrink h100">
                  <img class="no-shrink" v-show="baustoff == 'Halbfertigteil'" style="height: 100%; object-fit: cover; box-sizing: border-box; object-position: right;" :src="require('../assets/hohlkoerper_wireframes/' + (HKName.startsWith('CLS') ? (HKName == '' ? 'placeholder_wireframe' : HKName) : (HKTranslated == '' ? 'placeholder_wireframe' : HKTranslated) ) + '.svg')">
                  <div class="op0">
                    <gittertraeger       
                      :baustoff="baustoff" 
                      :dickeHalbfertigteil="dickeHalbfertigteil" 
                      :HKName="HKName" 
                      :BetondeckungUnten="BetondeckungUnten"
                      :BetondeckungOben="BetondeckungOben"
                      :BewehrungOben="BewehrungOben"
                      :zwischenlageUnten="zwischenlageUnten" 
                      :zwischenlageOben="zwischenlageOben"
                      :querbewehrung="querbewehrung" 
                      :sl_unterstuetzungshoehe="sl_unterstuetzungshoehe"
                      :Hohlkoerper="Hohlkoerper" 
                      :deckendicke="deckendicke"
                      :gHeight="gHeight"
                      :bewHFT="bewHFT"
                    />
                  </div>
                </div>
          </div>
        </div>

        <!-- HOHLKOERPER ORTBETON -->
        <div v-show="baustoff == 'Ortbeton'" class="overflow-hidden flex"  :style="{ height: (Hohlkoerper.unterstuetzungshoehe + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0)) / deckendicke * gHeight + 'px'}" >
          <div class="flex no-shrink h100" v-for="index in HKNumber" :key="'D' + index">
            <img ref="HkOBT" class="no-shrink" style="height: 100%;" :src="require('../assets/hohlkoerper_wireframes/' + (HKName.startsWith('CLS') ? (Hohlkoerper.name == '' ? 'placeholder_wireframe' : Hohlkoerper.name) : (HKTranslated == '' ? 'placeholder_wireframe' : HKTranslated) ) + '.svg')">
            <div class="no-shrink" :style="{ width: HKGap + 'px' }"></div>
          </div>
        </div>

        <!-- OBJECT AS PIXEL PERFECT SOLUTION? -->
        <!-- <div v-show="baustoff == 'Ortbeton'" class="overflow-hidden flex"  :style="{ height: (Hohlkoerper.unterstuetzungshoehe + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0)) / deckendicke * gHeight + 'px'}" >
          <div class="flex no-shrink h100" v-for="index in HKNumber" :key="'D' + index">
            <object type="image/svg+xml" ref="HkOBT" class="no-shrink" style="height: 100%;" :data="require('../assets/hohlkoerper_wireframes/' + (HKName.startsWith('CLS') ? (Hohlkoerper.name == '' ? 'placeholder_wireframe' : Hohlkoerper.name) : (HKTranslated == '' ? 'placeholder_wireframe' : HKTranslated) ) + '.svg')"></object>
            <div class="no-shrink" :style="{ width: HKGap + 'px' }"></div>
          </div>
        </div> -->

        <div v-show="Hohlkoerper.unterstuetzungshoehe > 0" class="meter-small">
            <div class="meter-slash-top"></div>
              <p class="meter-number">{{(Hohlkoerper.unterstuetzungshoehe + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0))|formatNumber}}</p>
            <div class="meter-slash-bottom"></div>
        </div>
      </div>

      <!-- ZWISCHENLAGE UNTEN -->
      <div v-show="zwischenlageUnten > 0" class="relative zwischenlage" :style="{ height: zwischenlageUnten / deckendicke * 100 + '%' }">
        <div class="meter-small">
          <div class="meter-slash-top"></div>
            <p class="meter-number">{{r_zwlU|formatNumber}}</p>
          <div class="meter-slash-bottom"></div>
        </div>
      </div>
      
      <!-- BEWEHRUNG UNTEN -->
      <div v-show="baustoff == 'Ortbeton' && BewehrungUnten > 0" class="relative" :style="{ height: BewehrungUnten / deckendicke * 100 + '%' }">
        <div class="bewehrung" style="height: 50%;"></div>
        <div class="bewehrung-circle-container flex justify-center overflow-hidden">
          <div class="no-shrink flex" v-for="index in calcBewDots" :key="'E' + index">
            <div class="bewehrung-circle" :style="{ height: 100 + '%', width: ((BewehrungUnten / 2) / deckendicke) * gHeight + 'px'}"></div>
            <div class="no-shrink" :style="{ width: bewehrungGap + 'px'}"></div>
          </div>
        </div>
        <div class="meter-small">
          <div class="meter-slash-top"></div>
            <p class="meter-number">{{r_bewU|formatNumber}}</p>
          <div class="meter-slash-bottom"></div>

        </div>
      </div>

      <!-- QUERBEWEHRUNG -->
      <div v-show="baustoff == 'Halbfertigteil' && querbewehrung > 0" class="querbewehrung relative" :style="{ height: querbewehrung / deckendicke * 100 + '%'}">
        <div class="meter-small">
          <div class="meter-slash-top"></div>
            <p class="meter-number">{{r_QB|formatNumber}}</p>
          <div class="meter-slash-bottom"></div>
        </div>
      </div>

      <!-- DICKE HALBFERTIGTEIL + GITTERTRAEGER -->
      <div v-show="baustoff == 'Halbfertigteil' && dickeHalbfertigteil" class="halbfertigteil relative" :style="{ height: dickeHalbfertigteil / deckendicke * 100 + '%' }">
        <div class="h100 border-box flex mx-auto">

              <div class="hft-bew-container flex absolute overflow-hidden no-shrink col-12" :style="{ bottom: (BetondeckungUnten / deckendicke) * gHeight + 'px'}">
                <div class="flex" v-for="index in calcBewHFT" :key="'F' + index">
                  <div class="flex no-shrink h100">
                    <div class="op0 npe no-shrink" :style="{ height: (Hohlkoerper.unterstuetzungshoehe + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0)) / deckendicke * gHeight + 'px'}">
                      <img v-if="baustoff == 'Halbfertigteil'" style="height: 100%; object-fit: cover; box-sizing: border-box; object-position: right;" :src="require('../assets/hohlkoerper_wireframes/' + (HKName.startsWith('CLS') ? (HKName == '' ? 'placeholder_wireframe' : HKName) : (HKTranslated == '' ? 'placeholder_wireframe' : HKTranslated) ) + '.svg')">
                    </div>
                    <gittertraeger       
                      :baustoff="baustoff" 
                      :dickeHalbfertigteil="dickeHalbfertigteil" 
                      :HKName="HKName" 
                      :BetondeckungUnten="BetondeckungUnten"
                      :BetondeckungOben="BetondeckungOben"
                      :BewehrungOben="BewehrungOben"
                      :zwischenlageUnten="zwischenlageUnten" 
                      :zwischenlageOben="zwischenlageOben"
                      :querbewehrung="querbewehrung" 
                      :sl_unterstuetzungshoehe="sl_unterstuetzungshoehe"
                      :Hohlkoerper="Hohlkoerper" 
                      :deckendicke="deckendicke"
                      :gHeight="gHeight"
                      :bewHFT="bewHFT"
                    />
                  </div>
                  </div>
                  <div class="op0 npe no-shrink" :style="{ height: (Hohlkoerper.unterstuetzungshoehe + (HKName.startsWith('SL') ? sl_unterstuetzungshoehe : 0)) / deckendicke * gHeight + 'px'}">
                    <img v-if="baustoff == 'Halbfertigteil'" style="height: 100%; object-fit: cover; box-sizing: border-box; object-position: right;" :src="require('../assets/hohlkoerper_wireframes/' + (HKName.startsWith('CLS') ? (HKName == '' ? 'placeholder_wireframe' : HKName) : (HKTranslated == '' ? 'placeholder_wireframe' : HKTranslated) ) + '.svg')">
                  </div>
                <div>
                  <svg id="gittertraeger" viewBox="0 0 509 713" class="gittertraeger npe no-shrink w-auto" fill="none" v-show="baustoff == 'Halbfertigteil' && dickeHalbfertigteil > 0 && HKName !== ''" :style="{ height: ((dickeHalbfertigteil - BetondeckungUnten + zwischenlageUnten + querbewehrung + sl_unterstuetzungshoehe + (Hohlkoerper.unterstuetzungshoehe / 2)) / deckendicke) * gHeight + 'px'}" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
                      <g transform="matrix(1,0,0,1,-884.464,-378.809)" stroke="#EE0044">
                          <g transform="matrix(1.47403,0.374743,-0.241412,0.949582,-3.52454,-1225.31)">
                              <rect x="962.931" y="1350.42" width="22.708" height="696.818" style="fill:none;stroke-width:4.89px;" stroke="2" stroke-dasharray="2"/>
                          </g>
                          <g transform="matrix(1,0,0,1,7.10184,-916.253)">
                              <circle cx="899.288" cy="1979.81" r="18.8" style="fill:none;stroke-width:6.25px;"/>
                          </g>
                          <g transform="matrix(1.3194,0,0,1.3194,-47.9432,-2205.43)">
                              <circle cx="899.288" cy="1979.81" r="18.8" style="fill:none;stroke-width:4.74px;"/>
                          </g>
                          <g transform="matrix(-1.47403,0.374743,0.241412,0.949582,2280.69,-1225.31)">
                              <rect x="962.931" y="1350.42" width="22.708" height="696.818" style="fill:none;stroke-width:4.89px;"/>
                          </g>
                          <g transform="matrix(-1,0,0,1,2270.19,-916.253)">
                              <circle cx="899.288" cy="1979.81" r="18.8" style="fill:none;stroke-width:6.25px;"/>
                          </g>
                      </g>
                  </svg>
                </div>
                                <!-- HALBFERTIGTEIL BEWEHRUNG PUNKTE -->
                  <div v-show="BetondeckungUnten > 0" class="col-12 bdU-inside flex justify-center overflow-hidden">
                      <div class="flex no-shrink" v-for="index in HFTDots" :key="'F' + index">
                        <div class="bewehrung-circle" :style="{ height: bewHFT + 'px', width: bewHFT + 'px'}"></div>
                        <div class="no-shrink" :style="{ width: bewehrungGap + 'px'}"></div>
                      </div>
                  </div>    
              </div>
        </div>  
        
        <div class="meter-small">
          <div class="meter-slash-top"></div>
            <p class="meter-number">{{r_DHFT|formatNumber}}</p>
          <div class="meter-slash-bottom"></div>
        </div>
      </div>

      <!-- BETONDECKUNG UNTEN -->
      <div v-if="BetondeckungUnten > 0 && baustoff == 'Ortbeton'" class="betondeckung relative" :style="{ height: BetondeckungUnten / deckendicke * 100 + '%' }">
        <div class="meter-small">
             <div class="meter-slash-top"></div>
            <p class="meter-number">{{r_bdU|formatNumber}}</p>
            <div class="meter-slash-bottom"></div>

        </div>
      </div>
    </div>  
  </div>


</template>

<script>
import gittertraeger from './gittertraeger.vue';

export default {
  name: 'Grafik',
  data() {
    return {
      componentReady: false,
      gHeight2: 0,
      gtWidth2: 0,
      HkWidth: 0,
    }
  },
  components: {
    'gittertraeger': gittertraeger
  },
  props: {
      BetondeckungOben: Number,
      BewehrungOben: Number,
      HoeheHohlkoeprersystem: Number,
      BetondeckungUnten: Number,
      BewehrungUnten: Number,
      Hohlkoerper: Object,
      zwischenlageOben: Number,
      zwischenlageUnten: Number,
      dickeHalbfertigteil: Number,
      baustoff: String,
      deckendicke: Number,
      querbewehrung: Number,
      sl_unterstuetzungshoehe: Number,
      activeSystem: String,
      chosen_system_translated: String,
      differenzDeckendicke: Number,
  },
  computed:{
    gHeight: function (){
      if(this.componentReady){
        return this.gHeight2
      }else{
        return 0
      }
    },
    sumO(){
      return this.BetondeckungOben + this.BewehrungOben + this.zwischenlageOben + (this.differenzDeckendicke >= 0 ? this.differenzDeckendicke : 0) + ((this.Hohlkoerper.unterstuetzungshoehe - this.Hohlkoerper.hohlraumhoehe)/2)
    },
    r_sumO: function (){
      var numb = +this.sumO.toFixed(1)
      return numb 
    },
    sumUOB: function (){
      return this.BetondeckungUnten + this.BewehrungUnten + this.zwischenlageUnten + (this.HKName.startsWith('SL') ? this.sl_unterstuetzungshoehe : 0) + ((this.Hohlkoerper.unterstuetzungshoehe - this.Hohlkoerper.hohlraumhoehe) / 2)
    },
    r_sumUOB: function (){
      var numb = +this.sumUOB.toFixed(1)
      return numb
    },
    sumUHFT: function(){
      return this.querbewehrung + this.dickeHalbfertigteil + this.zwischenlageUnten + (this.HKName.startsWith('SL') ? this.sl_unterstuetzungshoehe : 0) + ((this.Hohlkoerper.unterstuetzungshoehe - this.Hohlkoerper.hohlraumhoehe) / 2)
    },
    r_sumUHFT: function(){
      var numb = +this.sumUHFT.toFixed(1)
      return numb
    },
    dd_rest: function(){
      return Number(this.deckendicke) - Number(this.zwischenlageOben) - Number(this.BetondeckungOben) - Number(this.BewehrungOben) - Number(this.BewehrungUnten) - Number(this.BetondeckungUnten) - Number(this.zwischenlageUnten) - Number(this.Hohlkoerper.unterstuetzungshoehe)
    },
    bewehrungGap: function(){
      var w = (10/Number(this.deckendicke)) * this.gHeight
      return w 
    },
    bewHFT: function(){
      var n = Math.round((0.5/Number(this.deckendicke)) * this.gHeight)
      return n 
    },
    // HKGap: function(){
    //   if(this.Hohlkoerper.name.startsWith('SL')){

    //     var n = (35/Number(this.deckendicke) * Number(this.gHeight)) - Number(this.HkWidth)
    //     return n

    //   }
    //   if(this.Hohlkoerper.name.startsWith('CLS')){
    //     var m = (60/Number(this.deckendicke) * this.gHeight) - Number(this.HkWidth)
    //     return m
    //   }else{
    //     return 0 
    //   }
    // },
    HKGap: function(){
      if(this.Hohlkoerper.name.startsWith('CLS')){
        return 0;
      }
      else if(this.Hohlkoerper.name.startsWith('SL')){
        return (1.25/Number(this.deckendicke)) * this.gHeight;
      }
      else {
        return 0;
      }
    },
    calcBewDots: function(){
      var n = Math.round(this.deckendicke / 10 * 3)
      return n
    },
    calcBewHFT: function(){
      var n = Math.round(this.deckendicke / 10 * 3)
      return n
    },
    calcBewHFT2: function(){
      var n = Math.round(this.deckendicke / 10 * 3)
      return n
    },
    HKNumber: function(){
      var n = Math.round(this.deckendicke / 5 * 3)
      return n
    },
    r_bdO(){
      var numb = +this.BetondeckungOben.toFixed(1)
      return numb 
    },
    r_bdU(){
      var numb = +this.BetondeckungUnten.toFixed(1)
      return numb 
    },
    r_bewO(){
      var numb = +this.BewehrungOben.toFixed(1)
      return numb 
    },
    r_bewU(){
      var numb = +this.BewehrungUnten.toFixed(1)
      return numb 
    },
    r_QB(){
      var numb = +this.querbewehrung.toFixed(1)
      return numb 
    },
    r_DHFT(){
      var numb = +this.dickeHalbfertigteil.toFixed(1)
      return numb 
    },
    r_zwlO(){
      var numb = +this.zwischenlageOben.toFixed(1)
      return numb 
    },
    r_zwlU(){
      var numb = +this.zwischenlageUnten.toFixed(1)
      return numb 
    },
    gtWidth(){
      if(this.componentReady){
        return document.getElementById('gittertraeger').clientWidth
      }else{
        return this.gtWidth2
      }
    },
    HFTDots(){
      return 20
    },
    halfUh(){
      var numb = (this.Hohlkoerper.unterstuetzungshoehe - this.Hohlkoerper.hohlraumhoehe)/2
      return numb
    },

    HKName(){
      var w = this.Hohlkoerper.name
      return w
    },
    HKTranslated(){
      if(this.chosen_system_translated.startsWith('SL')){
              var w = this.chosen_system_translated
              return w
      }else{
        return '';
      }
    }


  },
  watch: {
    'Hohlkoerper.name'(newValue, oldValue){
      if(newValue != oldValue) {
        console.log('HK changed! Calling GetHkWidth...')
          this.getHKWidth();
        }
    },
  },

  mounted(){
    var el = document.getElementById('graphicbackground')
    this.gHeight2 = el.clientHeight;
    this.gtWidth2 = document.getElementById('gittertraeger').clientWidth
    this.componentReady = true; 
    this.getHKWidth();
    console.log('searching for gittertraeger...')
    console.log(this.$refs.gittertraeger)
  },
  methods: {
    getHKWidth(){
      if(this.baustoff == 'Ortbeton' && this.Hohlkoerper.name !== ''){
        console.log(this.$refs.HkOBT[0])
        console.log(this.$refs.HkOBT[0].clientWidth)
        this.HkWidth = this.$refs.HkOBT[0].clientWidth;
      }
      console.log('GetHkWidth Called!')
    },
    log: function (obj) {
      if(this.debug) {
        this.log(obj)
      }
    }
    
  }
}
</script>

<style scoped>

</style>